import React, { FC, ReactNode, useEffect, useState } from 'react'
import { Modal, ModalHeader } from 'reactstrap'
import { useSelector } from 'react-redux'

import LoadingIndicator from "./LoadingIndicator"

export interface ModalWrapperProps {
  /** Content to display inside the modal */
  children?: ReactNode
  /** Whether the modal is open */
  isOpen?: boolean
  /** Function to toggle the modal */
  toggle?: () => void
  /** Whether to unmount the modal when it's closed */
  unmountOnClose?: boolean
  /** Whether to show the loading indicator */
  showLoader?: boolean
  /** Title to display in the modal header */
  title?: string
  /** Additional props to pass to the Modal component */
  [key: string]: any
}

interface AppState {
  app: {
    loading: boolean
  }
}

const ModalWrapper: FC<ModalWrapperProps> = (props) => {
  const modalProps = {...props}
  const showLoader = modalProps.showLoader
  const title = modalProps.title
  delete modalProps.showLoader
  delete modalProps.title

  const loadingRedux = useSelector((state: AppState) => state.app.loading)
  const [initLoading, setInitLoading] = useState<boolean>(loadingRedux)
  const [show, setShow] = useState<boolean>(showLoader || false)
  const [firstAccess, setFirstAccess] = useState<boolean>(true)

  useEffect(() => {
    if (firstAccess) {
      if (loadingRedux) {
        setFirstAccess(false)
      }
    } else {
      if (!loadingRedux && show) {
        setShow(false)
      }
    }
  }, [loadingRedux, firstAccess, show])

  return (
    <Modal {...modalProps} toggle={!show ? modalProps.toggle : () => {}}>
      {
        title ? (
          show ? (
            <>
              <ModalHeader>
                {title}
              </ModalHeader>
              <LoadingIndicator loading={true}>
                {null}
              </LoadingIndicator>
            </>
          ) : (
            props.children
          )
        ) : (
          <LoadingIndicator loading={show}>
            {props.children}
          </LoadingIndicator>
        )
      }
    </Modal>
  )
}

export default ModalWrapper